/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UpdateRemoteSessionIssuerForm,
  UpdateRemoteSessionIssuerForm$Outbound,
  UpdateRemoteSessionIssuerForm$outboundSchema,
} from "../components/updateremotesessionissuerform.js";

export type UpdateGlobalRemoteSessionIssuerSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type UpdateGlobalRemoteSessionIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  updateRemoteSessionIssuerForm: UpdateRemoteSessionIssuerForm;
};

/** @internal */
export type UpdateGlobalRemoteSessionIssuerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const UpdateGlobalRemoteSessionIssuerSecurity$outboundSchema:
  z.ZodMiniType<
    UpdateGlobalRemoteSessionIssuerSecurity$Outbound,
    UpdateGlobalRemoteSessionIssuerSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function updateGlobalRemoteSessionIssuerSecurityToJSON(
  updateGlobalRemoteSessionIssuerSecurity:
    UpdateGlobalRemoteSessionIssuerSecurity,
): string {
  return JSON.stringify(
    UpdateGlobalRemoteSessionIssuerSecurity$outboundSchema.parse(
      updateGlobalRemoteSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type UpdateGlobalRemoteSessionIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  UpdateRemoteSessionIssuerForm: UpdateRemoteSessionIssuerForm$Outbound;
};

/** @internal */
export const UpdateGlobalRemoteSessionIssuerRequest$outboundSchema:
  z.ZodMiniType<
    UpdateGlobalRemoteSessionIssuerRequest$Outbound,
    UpdateGlobalRemoteSessionIssuerRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      updateRemoteSessionIssuerForm:
        UpdateRemoteSessionIssuerForm$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        updateRemoteSessionIssuerForm: "UpdateRemoteSessionIssuerForm",
      });
    }),
  );

export function updateGlobalRemoteSessionIssuerRequestToJSON(
  updateGlobalRemoteSessionIssuerRequest:
    UpdateGlobalRemoteSessionIssuerRequest,
): string {
  return JSON.stringify(
    UpdateGlobalRemoteSessionIssuerRequest$outboundSchema.parse(
      updateGlobalRemoteSessionIssuerRequest,
    ),
  );
}
